__turbopack_context__.v({
  "closeButton": "successModal-module-scss-module__rau9eW__closeButton",
  "logoContainer": "successModal-module-scss-module__rau9eW__logoContainer",
  "message": "successModal-module-scss-module__rau9eW__message",
  "modalContent": "successModal-module-scss-module__rau9eW__modalContent",
  "modalOverlay": "successModal-module-scss-module__rau9eW__modalOverlay",
  "title": "successModal-module-scss-module__rau9eW__title",
});
